/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type {ImageType} from '@enums'

import {useQuery} from '@tanstack/react-query'

import {getImage} from './api'
import {imageKeys} from './keys'

export const useGetImage = (type: ImageType, id?: string) => {
  return useQuery({
    queryKey: imageKeys.get(type, id || ''),
    queryFn: () => Promise.resolve(getImage(type, id!)),
    enabled: !!id,
    retry: false,
  })
}
